export default class UserPolicy {
    static browse(user) {
        return user.hasPermissionTo('browse:users');
    }

    static read(user, other) {
        if (other.id < 3) {
            return false;
        }

        return user.hasPermissionTo('read:users');
    }

    static edit(user, other) {
        return (user.id !== other.id || user.hasRole('admin'))
            && other.deleted_at === null
            && user.hasPermissionTo('edit:users');
    }

    static add(user) {
        return user.hasPermissionTo('add:users');
    }

    static destroy(user, other) {
        return user.id !== other.id
            && other.deleted_at === null
            && user.hasPermissionTo('delete:users');
    }

    static restore(user, other) {
        return user.id !== other.id
            && other.deleted_at !== null
            && user.hasPermissionTo('delete:users');
    }

    static changePassword(user, other) {
        return user.id !== other.id
            && other.id > 0
            && other.deleted_at === null
            && user.hasRole('admin');
    }
}
